export default "__VITE_ASSET__a5686aa0__"